<template>
  <div>
    <ul id="example-1">
      <li v-for="item in fileInfoForm.items"
          :key="item">
        <img :src="item"
             width="90%"
             height="90%" />
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data () {
    return {
      // 文件查看
      fileInfoVisible: false,
      fileInfoForm: {
        items: []
      }
    }
  },
  mounted () {
    this.getDataList()
  },
  methods: {
    getDataList () {
      this.$http.get(`/front/fileupload/alioss/showAliOssSvg/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res && res.code === 0) {
            this.fileInfoForm.items = res.data.svgList || []
            this.fileInfoVisible = true
          } else {
            // this.$message.error(data.data.message)
          }
        })
    }
  }
}
</script>
